export enum ManageTapchanStatus {
	free = 'Свободный',
	busy = 'Занятый',
	reserved = 'Забронированный'
}
export enum ManageTapchanType {
	vip = 'VIP',
	ordinary = 'Обычный'
}
